<template lang="pug">
  div(v-cloak)
    v-layout(row wrap)
      v-flex(xs12)
        v-toolbar(flat dense).secondary
          v-icon.white--text fa-cogs
          v-toolbar-title.white--text 簡易重量計算

    v-card
      v-card-text
        v-layout(row wrap)
          v-flex(xs12 sm6 md3)
            v-menu(
              lazy
              :close-on-content-click="false"
              v-model="periodDatePicker"
              transition="scale-transition"
              offset-y
              full-width
              :nudge-right="40"
              max-width="290px"
              min-width="290px"
              )
              v-text-field(
                label="計算基準日"
                slot="activator"
                :value="input.period_date|date"
                prepend-icon="schedule"
                outline
                readonly
                )
              v-date-picker(
                v-model="input.period_date"
                )
        v-layout(row wrap)
          v-flex(xs12 sm6 md3)
            v-text-field(
              type="number"
              label="幅"
              v-model="input.width"
              ref="width"
              :rules="[rules.required,rules.integer,rules.positive]"
              autocapitalize="off"
              suffix="mm"
              outline
            )
          v-flex(xs12 sm6 md3)
            v-text-field(
              type="number"
              label="奥行"
              v-model="input.height"
              ref="height"
              :rules="[rules.required,rules.integer,rules.positive]"
              autocapitalize="off"
              suffix="mm"
              outline
            )
          v-flex(xs12 sm6 md3)
            v-text-field(
              type="number"
              label="板厚"
              v-model="input.thick"
              ref="thick"
              :rules="[rules.required,rules.integer,rules.positive]"
              autocapitalize="off"
              suffix="mm"
              outline
            )
          v-flex(xs12 sm6 md3)
            v-text-field(
              type="number"
              label="枚数"
              v-model="input.num"
              ref="num"
              :rules="[rules.required,rules.integer,rules.positive]"
              autocapitalize="off"
              suffix="枚"
              outline
            )
      v-card-actions
        v-spacer
        v-btn(
          large
          color="primary"
          @click="calc"
        )
          v-icon(left) fa-cog
          span 計算して追加

    v-card
      v-card-text
        v-layout(row wrap)
          v-flex(xs12)
            div.app-line(v-for="(result, index) in results" :key="index")
              span.app-line-title {{index + 1}}) {{result.width}} mm x {{result.height}} mm x {{result.thick}} mm x {{result.num}} 枚
              span.app-line-text {{result.weight}}
              span.app-line-suffix kg
              span.app-line-suffix
                v-btn(icon small color="error" outline @click="removeRow(index)")
                  v-icon.rem10 close

      v-divider
      v-card-text
        v-layout(row wrap)
          v-flex(xs12)
            div.app-line
              span.app-line-title 合計
              span.app-line-text {{total|number(2)}}
              span.app-line-suffix kg
              span.app-line-suffix &nbsp;
</template>

<script>
import rules from '@/common/mixins/rules'
import mathjs from 'mathjs'

export default {
  data () {
    return {
      periodDatePicker: false,
      exclusiveLock: false,
      input: {
        period_date: this.$moment().format('YYYY-MM-DD'),
        width: 1000,
        height: 1000,
        thick: 9,
        num: 1
      },
      results: []
    }
  },
  mixins: [rules],
  created () {},
  beforeDestory () {},
  computed: {
    total () {
      return this.results
        .map(row => row.weight)
        .reduce((a, b) => mathjs.add(a, b), 0)
    }
  },
  methods: {
    calc () {
      if (this.hasRuleError()) {
        this.$toastr.warning(this.$t('_rules.invalidate_message'))
        return true
      }
      if (this.exclusiveLock) {
        return
      }
      this.exclusiveLock = true
      this.$ajax
        .post(`/calc/calc`, this.input)
        .then(response => {
          if (!response.data.status) {
            this.$toastr.warning(
              '計算ができませんでした。寸法を確認してください。'
            )
            return
          }
          this.results.push(response.data)
        })
        .finally(() => {
          this.exclusiveLock = false
        })
    },
    removeRow (index) {
      this.results.splice(index, 1)
    }
  }
}
</script>

<style scoped lang="stylus"></style>



// WEBPACK FOOTER //
// src/app/pages/Calc/index.vue